import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="horizontal-scroll"
// Scrolls the target container left/right when arrow buttons are clicked.
export default class extends Controller {
  static targets = ["scrollContainer"]

  static values = {
    step: { type: Number, default: 240 }
  }

  scrollLeft() {
    if (this.hasScrollContainerTarget) {
      this.scrollContainerTarget.scrollBy({ left: -this.stepValue, behavior: "smooth" })
    }
  }

  scrollRight() {
    if (this.hasScrollContainerTarget) {
      this.scrollContainerTarget.scrollBy({ left: this.stepValue, behavior: "smooth" })
    }
  }
}
